import { SecurityQuestionAnswer } from 'src/app/security/QueryStringParam';

export class UserProfileEntity {
  UserId: string;
  Password: string;
  EmailAddress: string;
  OldPassword: string;
  ConfirmPassword: string;
  PIN: string;
  CompanyName: string;
}

export class ForgotCredentialsModel {
  UserId: string;
  EmailAddress: string;
  Mode: string;
  CompanyName: string;
}

export interface AssociateAccount {
  AddrNum: number;
  AddrType: string;
  EmailAddress: string;
  Name: string;
  RecordNum: string;
  RecordType: string;
}

export class NewRegistrationModel {
  AccountNumber: string;
  PIN: string;
  TaxId: string;
  Zip: string;
  EmailAddress: string;
  ConfirmEmailAddress: string;
  UserId: string;
  Password: string;
  ConfirmPassword: string;
  TermsAndConditionAgreed: boolean;
  ElectronicMailAgreed: any;
}

export class MyProfileModel {
  ActivatedDate: string;
  DeactivatedDate: string;

  UserId: string;
  UserNum: string;
  EmailAddress: string;
  Phone: string;
  AltPhoneNum: string;
  FaxNum: string;
  Username: string;
  Password: string;
  TaxId: string;
  CurrAddressBegMonthDay: string;
  CurrAddressEndMonthDay: string;
  CurrAddressLine1: string;
  CurrAddressLine2: string;
  City: string;
  State: string;
  Zip: string;
  CityStateZip: string;
  Country: string;
  LegalAddressFlag: string;
  LegalAddressBegMonthDay: string;
  LegalAddressEndMonthDay: string;
  LegalAddressLine1: string;
  LegalAddressLine2: string;
  LegalCity: string;
  LegalState: string;
  LegalZip: string;
  LegalPhone: string;
  LegalCityStateZip: string;
  ListOtherLogins: AssociateAccount[];
  IsElectronicMailSubscribed: any;

  ListLinkAccounts: Array<any>;
  SecurityQuestionsSeqNum: number;
  SecurityQuestions: SecurityQuestionAnswer;

  SpecialInstruction: string; // Request Address Change

  WebportalOnlyFlag: string;  // ia_user_profile.wp_only_flag


  PIN?: string;
  AccountNum?: string;
  ConfirmPassword?: string;
  LegalAddressLine3?: string;
  AltPhoneText?: string;
  CurrAddressStatus?: any;
  LegalCountry: string;
  WpUserNum?: string;
}

export interface RegisterAccountModel {
  RecordType: 'I' | 'R';
  AccountNumber: number;
  Pin: string;
  TaxId: string;
  ZipCode: string;
  UserName: string;
  Password: string;
  EmailAddress: string;

  SecQuestionText1: string;
  SecQuestionCode1: string;
  SecAnswerText1: string;
  SecQuestionText2: string;
  SecQuestionCode2: string;
  SecAnswerText2: string;
  SecQuestionText3: string;
  SecQuestionCode3: string;
  SecAnswerText3: string;

  SendEmails: any;
}
